<div class="nav-container-2" [hidden]="selectedTabIndex==0">
    <div class="d-flex justify-content-between">
        <mat-tab-group (selectedTabChange)="viewTabClick($event)" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="" id="lblcommunication" class="primary"></mat-tab>
            <mat-divider [vertical]="true"></mat-divider>
            <mat-tab *ngFor="let tab of viewTabs; let index = index" [label]="tab.messageNumber" class="tabsrow">
                <ng-template mat-tab-label>
                    {{tab.messageNumber}}
                    <i class="fa fa-times-circle ml-3" (click)="closeTabClick(tab)" aria-hidden="true"></i>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<div class="" *ngIf="selectedTabIndex==0">
    <div class="nav-container-1">
        <div class="row eip-px-xs-10">
            <div class="col-xl-6 col-lg-4 col-md-12 col-sm-12 tab-container" style="margin-top: 10px;">
                <mat-tab-group [(selectedIndex)]="selectedRootIndex" (selectedTabChange)="tabClick($event)">
                    <mat-tab label="Inbox">
                        <ng-template mat-tab-label id="lblChallanList">
                            Inbox <span>{{inboxList.length}}</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Draft">
                        <ng-template mat-tab-label id="lblChallanList">
                            Draft <span>{{draftList.length}}</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Sent">
                        <ng-template mat-tab-label id="lblChallanList">
                            Sent <span>{{sentList.length}}</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="All">
                        <ng-template mat-tab-label id="lblChallanList">
                            All <span>{{allList.length}}</span>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 icons-container">
                <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-toggle-btn" style="width:100%" *ngIf="hasSuperView" [(ngModel)]='buttonType' (change)="onValChange(group.value)">
                    <mat-button-toggle value="MyMessages" class="btn-primary">My Messages</mat-button-toggle>
                    <mat-button-toggle value="Project" class="btn-primary">Other Messages</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="d-flex justify-content-end">
                    <div class="d-none d-md-block">
                        <i class="fa fa-search" title="Search" [ngClass]="{'active':isSearch}" aria-hidden="true" (click)="advanceSearch()" id="ibtSearch" aria-hidden="true" label="Advance Search"></i>
                        <i class="fa fa-plus-circle" aria-hidden="true" title="Create" *ngIf="canUpload" (click)="showCreateList($event)"></i>
                        <i class="fa fa-binoculars" aria-hidden="true" title="View" (click)="viewMessagesClick()"></i>
                        <i class="fa fa-reply" aria-hidden="true" title="Reply" *ngIf="canReply && mailBoxType!=2" (click)=respondMessage(1)></i>
                        <i class="fa fa-repeat-o" aria-hidden="true" title="Reply All" *ngIf="canReply && mailBoxType!=2" (click)=respondMessage(2)></i>
                        <i class="fa fa-forward" aria-hidden="true" title="Forward" *ngIf="canReply && mailBoxType!=2" (click)=respondMessage(3)></i>
                        <i class="fa fa-question-circle" aria-hidden="true" title="Help Manual" (click)="HelpUrlClick()"></i>
                    </div>
                </div>
                <div class="d-block d-md-none d-flex justify-content-end">
                    <i [matMenuTriggerFor]="moreIcons" class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    <mat-menu #moreIcons="matMenu" class="more-actions d-block d-md-none">
                        <button mat-menu-item (click)="advanceSearch()"> <i class="fa fa-search" title="Search" aria-hidden="true" id="lblASRAllCount" aria-hidden="true" title="Advance Search"></i> Advance Search</button>
                        <button mat-menu-item *ngIf="canReply && mailBoxType!=2" (click)=respondMessage(1)>
                            <i class="fa fa-reply" title="Reply" id="ibtASRAdd" aria-hidden="true"></i>
                            Reply</button>
                        <button mat-menu-item *ngIf="canReply && mailBoxType!=2" (click)=respondMessage(2)>
                            <i class="fa fa-repeat-o" title="Reply All" id="ibtASRAdd" aria-hidden="true"></i>
                            Reply All</button>
                        <button mat-menu-item *ngIf="canReply && mailBoxType!=2" (click)=respondMessage(3)>
                            <i class="fa fa-forward" title="Forward" id="ibtASRAdd" aria-hidden="true"></i>
                            Forward</button>
                        <button mat-menu-item (click)="viewMessagesClick()">
                            <i class="fa fa-external-link" title="View" id="ibtASRAdd" aria-hidden="true"></i>
                            View</button>
                        <button mat-menu-item *ngIf="canUpload" (click)="showCreateList($event)">
                            <i class="fa fa-plus-circle" title="Create" id="ibtASRAdd" aria-hidden="true"></i>
                            Create</button>
                    </mat-menu>
                </div>
                <kendo-popup class="order-popup eip-mr-15" popupClass="kendo-popup kendo-popup-right" [anchor]="anchorElementPopup" [anchorAlign]="anchorAlignRight" [popupAlign]="popupAlignRight" (anchorViewportLeave)="IsShowCreateList = false" *ngIf="IsShowCreateList" (click)="closeCreateList()">
                    <div class="kp-body">
                        <div class="d-flex menu-add" (click)="createMessageClick()" style="cursor: pointer;">
                            <p title="Message" class="eip-pxy-10" (click)="createMessageClick()">
                                Message</p>
                        </div>
                        <div class="d-flex  menu-add" (click)="registerMessageClick()" style="cursor: pointer;">
                            <p title="Register Incoming Message" class="eip-pl-10 eip-pr-10" (click)="registerMessageClick()">
                                Register Incoming Message</p>
                        </div>
                        <div class="d-flex  menu-add" (click)="openMessageGroupPopup()" style="cursor: pointer;">
                            <p title="Message Group" class="eip-pl-10 eip-pr-10 " (click)="openMessageGroupPopup()">
                                Message Group</p>
                        </div>
                        <div class="d-flex  menu-add" (click)="openSignaturePopup()" style="cursor: pointer;">
                            <p title="Signature" class="eip-pl-10 eip-pr-10" (click)="openSignaturePopup()">
                                Signature</p>
                        </div>
                    </div>
                </kendo-popup>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="isSearch">
            <app-mail-advance-search [searchList]="messageList" [tranType]="buttonType" (advancedSearchStatus)="closeAdvSearch($event)">
            </app-mail-advance-search>
        </div>
        <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
            <kendo-grid #mailGrid [kendoGridBinding]="messageList" [height]="550" [pageable]="true" [pageSize]="pageSize" id="mailLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [selectable]="true" (selectionChange)="onSelectionChange($event)" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid" (mouseover)="onHover($event)">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <ng-template kendoGridToolbarTemplate>
                    <div class="k-grid-toolbar-content d-flex">
                        <div class="flex-grow-1 title-container">
                            <p class="title">Details -</p>
                            <div class="pagination-container details-section">
                                <p class="d-none d-sm-flex">Viewing last</p>
                                <kendo-dropdownlist [data]='noOfDays' [value]="LastViewingRecord" (valueChange)="lastviewingrecordsmethod($event)" class="eip-mr-5 eip-ml-5" id="lblViewingLastDaysRecords" style="margin: 0px;"> </kendo-dropdownlist>
                                <p class="d-none d-sm-flex">days records</p>
                            </div>
                        </div>
                        <div class="pagination-container">
                            <p id="lblShowDetails">Show</p>
                            <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                            </kendo-pager-page-sizes>
                            <span>Items</span>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="icons-container">
                            <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                            <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                <div class="icon-wrap">
                                    <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                    <span class="list-icon-name">Filter</span>
                                </div>
                                <div class="icon-wrap">
                                    <span class="list-icon-name">Grid Settings</span>
                                </div>
                                <div class="icon-wrap">
                                    <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}" (click)="toggleFullscreen()"></i>
                                    <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                </div>
                            </div>
                            <div class="icon-wrap">
                                <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to Excel</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <kendo-grid-checkbox-column showSelectAll="true" width="20"></kendo-grid-checkbox-column>
                <kendo-grid-column field="messageNumber" title="Message No" width="130">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <i aria-hidden="true" title="Attachment" *ngIf="dataItem.hasAttachments"  (click)="viewAttachmentClick(dataItem)" class="fa fa-paperclip fs-16 eip-mr-5 eip-link"></i>
                        <span class="no-wrap eip-link" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto" (click)="viewMessageClick(dataItem)">
                            {{dataItem.messageNumber}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="messageList" Field="messageNumber"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="messageSubject" title="Subject" width="130">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">{{dataItem.messageSubject}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="messageList" Field="messageSubject"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="from" title="From" width="90" id="from">
                    <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                        From
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.from}}" eipTooltipPosition="auto"> {{dataItem.from}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="messageList" Field="from"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="to" title="To" width="150" id="to">
                    <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                        To
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.to}}" eipTooltipPosition="auto"> {{dataItem.to}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="messageList" Field="to"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="status" title="Status" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="k-grid-status" [class.cancelled]="" [class.rejected]="dataItem.status=='Overdue'" [class.submitted]="dataItem.status=='Pending'" [class.draft]="" [class.approved]="" [class.send_back]="dataItem.status=='Read'" [class.hold]="" [class.accepted]="dataItem.status=='Responded'" [class.closed]="" [class.amber]="dataItem.status=='Unread'"></span>
                        <span class="no-wrap  eip-link" eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto" (click)="viewStatusLog(dataItem)">
                            {{dataItem.status}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-dropdown-filter [filter]="filter" [data]="messageList" Field="status"></app-dropdown-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="sentOn" title="Sent On" *ngIf="mailBoxType!=1" width="90" id="GrlblStatus">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.sentOn | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.sentOn | date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-datepicker-filter [filter]="filter" field="sentOn"></app-datepicker-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="sentOn" title="Received On" *ngIf="mailBoxType==1" width="90" id="GrlblStatus">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.sentOn| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.sentOn| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-datepicker-filter [filter]="filter" field="sentOn"></app-datepicker-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="responseDate" title="Date Of Response" width="90">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.responseDate| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.responseDate| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                    <ng-template kendoGridFilterCellTemplate let-filter>
                        <app-datepicker-filter [filter]="filter" field="responseDate"></app-datepicker-filter>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="action" title="" width="10" filter='false'>
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="floating-icon icon-container d-flex align-items-center">                            
                            <i class="fa fa-pencil" title="Edit" *ngIf="dataItem.messageBox == 2" (click)="editMessage(dataItem)" aria-hidden="true"></i>
                            <i class="fa fa-trash" title="Delete" *ngIf="canDelete && dataItem.messageBox != 1 && dataItem.messageCategory!=3" (click)="deleteMessage(dataItem)" aria-hidden="true"></i>
                            <i class="fa fa-reply" aria-hidden="true" title="Reply" *ngIf="canReply && dataItem.messageBox != 2" (click)=respondMessage(1,dataItem)></i>
                            <i class="fa fa-repeat-o" aria-hidden="true" title="Reply All" *ngIf="canReply && dataItem.messageBox != 2" (click)=respondMessage(2,dataItem)></i>
                            <i class="fa fa-forward" aria-hidden="true" title="Forward" *ngIf="canReply && dataItem.messageBox != 2" (click)=respondMessage(3,dataItem)></i>
                            <i class="fa fa-history" title="History" (click)="viewHistoryLog(dataItem)" aria-hidden="true"></i>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-excel fileName="CommunicationList.xlsx" [fetchData]="allData"></kendo-grid-excel>
            </kendo-grid>
        </div>
    </div>
</div>
<div *ngIf="selectedTabIndex!=0">
    <app-mail-view [viewData]="viewData"></app-mail-view>
</div>